<template>
  <div class="not-found">
    <h1>你来到了一个信息的荒漠🌵</h1>
    <p>404-抱歉，您访问的页面不存在。</p>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
.not-found {
  text-align: center;
  padding: 50px;
}
</style>
